import type { IconSvgObject } from './types';

const HydroPowerIcon: IconSvgObject = [
  ["path", { d: "M9.5 4.5L9.95918 2C5.96094 2.8116 2.8116 5.96094 2 9.95918M19.5 9.5L22 9.95918C21.1884 5.96094 18.0391 2.8116 14.0408 2M14.5 19.5L14.0408 22C18.0391 21.1884 21.1884 18.0391 22 14.0408M9.95918 22C5.96094 21.1884 2.8116 18.0391 2 14.0408L4.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 7.5C12 7.5 8 10 8 12.7551C8 14.6012 9.51472 16.5 12 16.5C14.4853 16.5 16 14.6012 16 12.7551C16 10 12 7.5 12 7.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HydroPowerIcon;
